import { Heading, HeadingProps } from '@bonusly/design-system';

export const SectionHeading = ({ children, ...rest }: HeadingProps) => {
	return (
		<Heading as="h2" size="2xl" {...rest}>
			{children}
		</Heading>
	);
};
